<template>
  <div class="AiAccodionItemContent">
    <div v-if="picture?.srcSet" class="AiAccodionItemContent-image">
      <ai-image
        :src="picture.src"
        :src-set="picture.srcSet"
        :alt="picture.alt ?? ''" />
    </div>
    <div
      v-else
      class="AiAccodionItemContent-image AiAccodionItemContent-image--placeholder">
      <ai-icon
        name="photo"
        :size="32"
        class="AiAccodionItemContent-image--icon" />
    </div>
    <ai-typo
      v-if="description"
      class="AiAccodionItemContent-description"
      as="p"
      variant="paragraph-03-regular"
      color="white">
      {{ description }}
    </ai-typo>

    <ai-link
      v-if="link"
      :underline="false"
      class="AiAccodionItemContent-link"
      typo-variant="button-bold"
      color="gold-300"
      :url="link"
      :text="$t('homepage.discoverMoreCtaLabel')"
      :title="title"
      icon-right="button-arrow-right"
      target="_blank" />
  </div>
</template>

<script setup lang="ts">
import type { AiPicture } from '~~/domains/graphql';

type Props = {
  title: string;
  description: string | null;
  link?: string;
  picture?: AiPicture | null;
};

withDefaults(defineProps<Props>(), {
  link: '',
  picture: null,
});
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/mixins';
@use '@/assets/styles/utilities/mq';

.AiAccodionItemContent {
  margin-bottom: constants.$margin-04;

  @media (mq.$from-medium) {
    margin-left: constants.$margin-06;
  }
}

.AiAccodionItemContent-image {
  width: 100%;
  margin-bottom: constants.$margin-02;
  @include mixins.rem-fallback(height, 217);

  &--placeholder {
    background: colors.$neutral-300;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--icon {
    color: colors.$neutral-500;
  }

  @media (mq.$from-medium) {
    display: none;
  }
}
.AiAccodionItemContent-description {
  position: relative;
  margin-bottom: constants.$margin-01;
}

.AiAccodionItemContent-link {
  text-decoration: none;
  text-transform: uppercase;
  color: colors.$gold-300;
}
</style>
